import { jsx, jsxs } from "react/jsx-runtime";
import { TextLink, Box, Text, Hidden } from "braid-design-system";
import omit from "lodash/omit.js";
import { CUSTOMER_SERVICE_PHONE_NUMBER } from "@seek/shared-constants";
import { analyticsEvents, analyticsGlobalFooterEvents } from "../AuthenticatedFooterLinks/AuthenticatedFooterLinks.mjs";
import { generalLink } from "../EmployerFooter.css.mjs";
const CustomerServicePhoneNumber = ({
  site,
  contactNumber,
  onTrackedItemInteraction = () => {
  }
}) => {
  const csPhoneNumber = contactNumber || CUSTOMER_SERVICE_PHONE_NUMBER[site];
  if (csPhoneNumber) {
    return /* @__PURE__ */ jsx(
      TextLink,
      {
        href: `tel:${csPhoneNumber}`,
        data: { analytics: analyticsEvents.TRACK_CS_PHONE },
        onClick: () => {
          onTrackedItemInteraction({
            ...analyticsGlobalFooterEvents.call,
            actionPressed: `${analyticsGlobalFooterEvents.call.actionPressed} (${csPhoneNumber})`
          });
        },
        children: csPhoneNumber
      }
    );
  }
  return null;
};
const ContactUsLink = ({
  href,
  site,
  label,
  linkRenderer: LinkRenderer,
  contactNumber,
  onTrackedItemInteraction = () => {
  },
  ...restProps
}) => /* @__PURE__ */ jsx(
  Box,
  {
    display: ["block", "inline"],
    paddingTop: ["small", "none"],
    paddingBottom: ["medium", "xsmall"],
    children: /* @__PURE__ */ jsxs(Text, { size: "small", weight: "medium", children: [
      /* @__PURE__ */ jsx(
        LinkRenderer,
        {
          href,
          className: generalLink,
          ...omit(restProps, ["specificSite"]),
          children: label
        }
      ),
      /* @__PURE__ */ jsxs(Hidden, { inline: true, below: "tablet", children: [
        " ",
        /* @__PURE__ */ jsx(
          CustomerServicePhoneNumber,
          {
            contactNumber,
            site,
            onTrackedItemInteraction
          }
        )
      ] })
    ] })
  }
);
export {
  ContactUsLink
};
